export default "__VITE_ASSET__DZj46WRl__"